import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import DateComponent from "components/List/components/Date";
import Hour from "components/List/components/Hour";
import {dangerColor} from "assets/jss/main";

PushErrorDate.propTypes = {
    retailer: PropTypes.object.isRequired,
};

function PushErrorDate({retailer}) {
    if (!retailer.lastPushedProductDate) {
        return <FormattedMessage id={'retailer.list.table.pushColumn.noPushFound'} />;
    }

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '4px',
        }}>
            <div style={{display:'flex', flexDirection: 'column', lineHeight: '1'}}>
                <DateComponent date={retailer.lastPushedProductDate} />
                <Hour date={retailer.lastPushedProductDate} />
            </div>
            {retailer.numberOfErrorOnPushedProduct > 0 &&
                <span style={{color: dangerColor, fontWeight: 600, fontSize: '14px'}}>
                    {retailer.numberOfErrorOnPushedProduct}
                </span>
            }
        </div>
    );
}

export default PushErrorDate;
